import Joi from 'joi';

/**
 * Schema for platform settings updates.
 */
export const updatePlatformSettingsSchema = () =>
	Joi.object({
		notifications: Joi.object().unknown(true).allow(null),
	}).unknown();
